module.exports = __webpack_public_path__ + "static/member-1-67ecd76d86a43cb68c9d5e86aea9b810.png";